module.exports = __webpack_public_path__ + "img/jk-g.ee9f7875.png";